"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementsEnumerated = exports.VSelectionList = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var EmptyData_1 = require("./EmptyData");
var VSelectionList = (function (_super) {
    __extends(VSelectionList, _super);
    function VSelectionList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            listSelected: _this.props.elements.filter(function (e) { return e.active; })
        };
        _this.isActive = function (elements) {
            return !!_this.state.listSelected.find(function (e) { return e.value === elements.value; });
        };
        _this.onItemClick = function (active, element, event) {
            var newElement = __assign(__assign({}, element), { active: !element.active });
            _this.props.onSelect(newElement, event);
        };
        _this.getElevation = function (elevation) {
            switch (elevation) {
                case 0:
                    return core_1.Classes.ELEVATION_0;
                case 1:
                    return core_1.Classes.ELEVATION_1;
                case 2:
                    return core_1.Classes.ELEVATION_2;
                case 3:
                    return core_1.Classes.ELEVATION_3;
                case 4:
                    return core_1.Classes.ELEVATION_4;
                default:
                    return core_1.Classes.ELEVATION_0;
            }
        };
        _this.getElements = function (elements) {
            return _this.props.enableEnumeration
                ? (0, exports.getElementsEnumerated)(elements)
                : elements;
        };
        return _this;
    }
    VSelectionList.prototype.render = function () {
        var _this = this;
        var _a = this.props, elements = _a.elements, selection = _a.selection, elevation = _a.elevation, className = _a.className, padding = _a.padding, height = _a.height, getTemplate = _a.getTemplate;
        return (react_1.default.createElement(style_1.SelectionListContainer, { height: height }, (elements && elements.length) > 0 ? (react_1.default.createElement(style_1.StyledMenu, { className: "".concat(this.getElevation(elevation || 0), " ").concat(className), padding: padding }, this.getElements(elements).map(function (element) {
            var _a;
            var active = element.active, text = element.text, value = element.value, icon = element.icon;
            var backgroundColor = !!selection && !!selection.background
                ? selection.background
                : '#0072ce';
            var textColor = !!selection && !!selection.textColor
                ? selection.textColor
                : 'white';
            return (react_1.default.createElement(style_1.StyledMenuItem, { key: value, active: active, background: backgroundColor, color: textColor, text: (_a = getTemplate === null || getTemplate === void 0 ? void 0 : getTemplate(element)) !== null && _a !== void 0 ? _a : text, onDoubleClick: function () {
                    _this.props.onDoubleClick(element);
                }, onClick: function (event) {
                    _this.onItemClick(active || false, element, event);
                }, icon: icon }));
        }))) : (react_1.default.createElement(EmptyData_1.EmptyData, { settings: undefined }))));
    };
    return VSelectionList;
}(react_1.Component));
exports.VSelectionList = VSelectionList;
var getElementsEnumerated = function (elements) {
    return elements.map(function (item, index) { return (__assign(__assign({}, item), { text: "".concat(index + 1, ") ").concat(item.text) })); });
};
exports.getElementsEnumerated = getElementsEnumerated;
